<ng-container *ngIf="entityType == 'EKAMPUS'">
  <app-footerEkampus></app-footerEkampus>
</ng-container>
<ng-container *ngIf="entityType == 'IP'">
  <app-footerIP></app-footerIP>
</ng-container>

<!-- end main content-->

